import React from "react";

function CustomBadgeBronze({ children, style, className = "" }) {
    return (
        <div className={`custom-badge-bronze ${className}`} style={style}>
            {children}
        </div>
    );
}

export default function BadgeGroup({ badges = [] }) {
    return (
        <div className="badge-group-custom badge-group--on-image">
            {badges.map((badge, idx) => (
                <CustomBadgeBronze key={idx} style={badge.style}>
                    {badge.content}
                </CustomBadgeBronze>
            ))}
        </div>
    );
}
